import { PropertyType } from "../common/PropertyTypes";

export enum CustomListType {
    ProcessingActivity = 0,
    Sharing = 1,
    // 2 was System. Retired, but the ordinal is reserved to match the backend enum, where existing
    // customers still have System rows persisted as INT.
    Company = 3,
}

export enum CallPage {
    GroupCompanies,
}

export interface CustomListSaveModel {
    name: string;
    description: string;
    type: CustomListType;
}

export interface CustomListsViewModel {
    id: string;
    name: string;
    description: string;
    isStandardList: boolean;
    columns: Array<PropertyType>;
}

export enum ContentType {
    Text,
    List,
    Number,
    Date,
    Boolean,
    Decimal,
}
